<h3 *ngIf="showTitle" translate="JobNew.ConfirmNew" class="mb-3"></h3>

<!--if (Model.SourceID != "CONWEB") {
<div class="alert alert-info print-only">
This request has not been submitted yet.<br /> Printout is for verification purposes <br />@DateTime.Now
</div>
}-->

<div id="confirmDetails">

<ng-container *ngIf="displaySection('contact')">
    <h4 translate="Job.Contact"></h4>
    <hr />
    <dl class="row">
        <dt class="col-3" translate="Contact.Title"></dt>
        <dd class="col-9">{{ job.contact.title }}</dd>

        <dt class="col-3" translate="Contact.FirstName"></dt>
        <dd class="col-9">{{ job.contact.firstName }}</dd>

        <dt class="col-3" translate="Contact.LastName"></dt>
        <dd class="col-9">{{ job.contact.lastName }}</dd>

        <ng-container *hasTranslation="'Contact.Company'">
            <dt class="col-3" translate="Contact.Company"></dt>
            <dd class="col-9">{{ job.contact.companyName }}</dd>
        </ng-container>

        <dt class="col-3" translate="Contact.EmailAddress"></dt>
        <dd class="col-9">{{ job.contact.emailAddress }}</dd>

        <dt class="col-3" translate="Contact.Mobile"></dt>
        <dd class="col-9">{{ job.contact.mobile }}</dd>

        <dt class="col-3" translate="Contact.OfficeHours"></dt>
        <dd class="col-9">{{ job.contact.officeHours }}</dd>

        <dt class="col-3" translate="Contact.AfterHours"></dt>
        <dd class="col-9">{{ job.contact.afterHours }}</dd>
    </dl>
</ng-container>

<ng-container *ngIf="displaySection('address')">
    <h4 translate="Job.Address"></h4>
    <hr />
    <dl class="row">
        <dt class="col-3" translate="Address.Line1"></dt>
        <dd class="col-9">{{ job.address.lines[0] }}</dd>

        <dt class="col-3" translate="Address.Line2"></dt>
        <dd class="col-9">{{ job.address.lines[1] }}</dd>

        <dt class="col-3" translate="Address.Line3"></dt>
        <dd class="col-9">{{ job.address.lines[2] }}</dd>

        <dt class="col-3" translate="Address.Line4"></dt>
        <dd class="col-9">{{ job.address.lines[3] }}</dd>

        <dt class="col-3" translate="Address.Line5"></dt>
        <dd class="col-9">{{ job.address.lines[4] }}</dd>
    </dl>
</ng-container>

<ng-container *ngIf="displaySection('machine')">
    <h4 translate="Job.Machine"></h4>
    <hr />
    <dl class="row">
        <dt class="col-3" translate="Machine.ModelID"></dt>
        <dd class="col-9">{{ job.machine.modelId }}</dd>

        <dt class="col-3" translate="Machine.MachineName"></dt>
        <dd class="col-9">{{ job.machine.name }}</dd>

        <dt class="col-3" translate="Machine.Serial"></dt>
        <dd class="col-9">{{ job.machine.serialNumber }}</dd>

        <dt class="col-3" translate="Machine.DateOfPurchase"></dt>
        <dd class="col-9">{{ job.machine.dateOfPurchase | date }}</dd>

        <ng-container *hasTranslation="'Machine.Field1'">
            <dt class="col-3" translate="Machine.Field1"></dt>
            <dd class="col-9">{{ job.machine.fields[0] }}</dd>
        </ng-container>
        <ng-container *hasTranslation="'Machine.Field2'">
            <dt class="col-3" translate="Machine.Field2"></dt>
            <dd class="col-9">{{ job.machine.fields[1] }}</dd>
        </ng-container>
        <ng-container *hasTranslation="'Machine.Field3'">
            <dt class="col-3" translate="Machine.Field3"></dt>
            <dd class="col-9">{{ job.machine.fields[2] }}</dd>
        </ng-container>
        <ng-container *hasTranslation="'Machine.Field4'">
            <dt class="col-3" translate="Machine.Field4"></dt>
            <dd class="col-9">{{ job.machine.fields[3] }}</dd>
        </ng-container>
        <ng-container *hasTranslation="'Machine.Field5'">
            <dt class="col-3" translate="Machine.Field5"></dt>
            <dd class="col-9">{{ job.machine.fields[4] }}</dd>
        </ng-container>

        <dt class="col-3" translate="Machine.BranchID"></dt>
        <dd class="col-9" [abiLookupdisplay]="job.machine.dealerBranchId" listName="DealerBranch"></dd>
    </dl>
</ng-container>

<ng-container *ngIf="displaySection('job')">
    <h4 translate="Job.Service"></h4>
    <hr />
    <dl class="row">
        <dt class="col-3" translate="Job.Source"></dt>
        <dd class="col-9">{{ 'JobNew.Source' | translate }} {{ source }}</dd>

        <dt class="col-3" translate="Job.TypeID"></dt>
        <dd class="col-9" [abiLookupdisplay]="job.typeId" listName="CodeJobType"></dd>

        <dt class="col-3" translate="Job.FaultCodeID"></dt>
        <dd class="col-9" [abiLookupdisplay]="job.faultCodeId" listName="CodeJobFault"></dd>

        <dt class="col-3" translate="Job.FaultDescription"></dt>
        <dd class="col-9">{{ job.faultDescription }}</dd>

        <ng-container *ngIf="fileUploadEnabled">
            <dt class="col-3" translate="Job.FileUpload"></dt>
            <dd class="col-9">{{ getFileNames().join(", ") }}</dd>
        </ng-container>

        <ng-container *ngIf="jobAtBranch">
            <dt class="col-3" translate="JobAtBranch.BranchID"></dt>
            <dd class="col-9" [abiLookupdisplay]="job.visits[0].dealerBranchId" listName="DealerBranch"></dd>

            <dt class="col-3" translate="JobAtBranch.BookingDate"></dt>
            <dd class="col-9">{{ job.visits[0].booked | date }}</dd>

            <dt class="col-3" translate="JobAtBranch.TimeSlot"></dt>
            <dd class="col-9">{{ job.visits[0].booked | date:'shortTime' }}</dd>
        </ng-container>
    </dl>
</ng-container>


<ng-container *ngIf="displaySection('dealer')">
    <ng-container *ngIf="job.dealerContact && (job.dealerContact?.lastName || job.dealerContact?.firstName || job.dealerContact?.companyName)">
        <h4 translate="Job.Dealer"></h4>
        <hr />
        <dl class="row">
            <dt class="col-3" translate="Contact.Title"></dt>
            <dd class="col-9">{{ job.dealerContact?.title }}</dd>

            <dt class="col-3" translate="Contact.FirstName"></dt>
            <dd class="col-9">{{ job.dealerContact?.firstName }}</dd>

            <dt class="col-3" translate="Contact.LastName"></dt>
            <dd class="col-9">{{ job.dealerContact?.lastName }}</dd>

            <ng-container *hasTranslation="'Contact.Company'">
                <dt class="col-3" translate="Contact.Company"></dt>
                <dd class="col-9">{{ job.dealerContact?.companyName }}</dd>
            </ng-container>

            <dt class="col-3" translate="Contact.Email"></dt>
            <dd class="col-9">{{ job.dealerContact?.emailAddress }}</dd>

            <dt class="col-3" translate="Contact.Mobile"></dt>
            <dd class="col-9">{{ job.dealerContact?.mobile }}</dd>

            <dt class="col-3" translate="Contact.OfficeHours"></dt>
            <dd class="col-9">{{ job.dealerContact?.officeHours }}</dd>

            <dt class="col-3" translate="Contact.AfterHours"></dt>
            <dd class="col-9">{{ job.dealerContact?.afterHours }}</dd>
        </dl>
    </ng-container>
</ng-container>

</div>
